<template>
  <div>
    <!-- begin::Footer -->
    <footer class="m-grid__item m-footer ">
      <div class="m-container m-container--fluid m-container--full-height m-page__container">
        <div class="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
          <div class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
            <span class="m-footer__copyright"> 2020 &copy; Student Portal by <a href="https://webcolms.com" class="m-link"><img src="/media/logos/webco-lms.png" width="70"></a>
            </span>
          </div>
          <div class="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
            <ul class="m-footer__nav m-nav m-nav--inline m--pull-right">
              <li class="m-nav__item">
                <a href="#"  class="m-nav__link">
                  <span class="m-nav__link-text">Privacy</span>
                </a>
              </li>
              <li class="m-nav__item">
                <a href="#" class="m-nav__link">
                  <span class="m-nav__link-text">T&C</span>
                </a>
              </li>
              <li class="m-nav__item m-nav__item">
                <a href="#" class="m-nav__link" data-toggle="m-tooltip" title="Support Center" data-placement="left">
                  <i class="m-nav__link-icon flaticon-info m--icon-font-size-lg3"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
    <!-- end::Footer -->
  </div>
</template>

<script>

export default {

  name: 'footer',

  data () {
    return {

    }
  },

  methods: {

  }

}

</script>

<style scoped lang="scss">
  @import "../../assets/scss/component/footer/footer";
   @media (max-width:767px) {
     .m-footer {
        display: none;
      }
  }
  .m-footer {
    height: 67px !important;
  }

//   @media (min-width: 1025px){
//   .m-footer--push.m-aside-left--enabled:not(.m-footer--fixed) .m-footer {
//     margin-top: 0;
//     margin-left: 255px;
//     padding-left: 75px;
//   }

//     .m-footer--push.m-aside-left--enabled:not(.m-footer--fixed).m-aside-left--minimize .m-footer {
//     margin-left: 60px;
//   }

// }

//   @media (max-width:767px) {
//      .m-footer {
//         height: auto !important;
//         display: none;
//       }

//     .m-footer--push.m-aside-left--enabled:not(.m-footer--fixed) .m-footer {
//         margin-left: 0px !important;
//     }

//     .m-footer--push.m-aside-left--enabled:not(.m-footer--fixed).m-aside-left--minimize .m-footer {
//         margin-left: 0px !important;
//     }
// }​



//   .m-footer--push.m-aside-left--enabled:not(.m-footer--fixed).m-aside-left--minimize .m-footer {
//     margin-left: 60px;
//   }
//     .m-footer {
//     height: 80px !important;
//   }

</style>
